import classNames from 'classnames';
import { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import BackButton from '../../components/BackButton';
import { Separator } from '../../components/Separator/Separator';
import { TicketContext } from '../../contexts/TicketContext';
import { useDocumentBodyStyle } from '../../helpers/hooks/useDocumentBodyStyle';
import { useScrollToTop } from '../../helpers/hooks/useScrollToTop';
import { TicketRoutePaths } from '../../interfaces/Routes';
import usePageTitle from '../../services/hooks/usePageTitle';
import StepsService from '../../services/StepsService';
import styles from './Contact.module.scss';
import PhoneSection from './PhoneSection';

const ContactPage: FC = () => {
  const { ticket } = useContext(TicketContext);

  const { t } = useTranslation();

  usePageTitle(t('pageTitle:contact'));
  useDocumentBodyStyle({ backgroundColor: '#FFFFFF' });
  useScrollToTop();

  const imageContainerStyles = classNames('background-color', styles.imagesContainer);

  return (
    <div className={styles.container}>
      <div className={styles.contactContainer}>
        <BackButton ariaLabel={t('button:back')} text={t('button:back')} useRouter />
        <h1 dangerouslySetInnerHTML={{ __html: t('contact:title') }} />
        <Separator />
        <div>
          <h2>{t('contact:faq')}</h2>
          <Link className={styles.faqLink} to={StepsService.getStepUri(ticket?.hashId, TicketRoutePaths.faq)}>
            {t('contact:faqLink')}
          </Link>
        </div>
        <PhoneSection />
      </div>
      <div className={imageContainerStyles}>
        <div className={styles.images}>
          <img alt={t('contactPageAlts:technicians')} src="/assets/technicians.png" />
          <img alt={t('contactPageAlts:office')} className={styles.office} src="/assets/office.png" />
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
